import { useUIColors } from '@/core/hooks';
import React from 'react';
import { View } from 'react-native';
import UploadSvg from '@assets/images/svg/upload.svg';

export interface UploadIconProps {
    size?: number;
    color?: string;
}

export function UploadIcon({ size = 18, color }: UploadIconProps) {
    const colors = useUIColors();
    const strokeColor = color || colors.vectorsIconGreyscale;

    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <UploadSvg width={size} height={size} color={strokeColor} />
        </View>
    );
}

export default UploadIcon;

